import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const LoginSchema = (): yup.AnyObjectSchema => {
  const { t } = useTranslation();

  const required = t('common.formErrorMessages.required');

  const schema = yup
    .object({
      emailUsername: yup.string().required(required),
      password: yup.string().required(required),
      termsAndCondition: yup.boolean().oneOf([true], ''),
      dncRegistry: yup.boolean().oneOf([true], ''),
    })
    .required();

  return schema;
};
